import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  paper: {
    padding: '50px'
  }
}));

const Empty = (props) => {
  const { children } = props;

  const classes = useStyles();

  return (
    // <div
    //   className={clsx({
    //     [classes.root]: true,
    //     [classes.shiftContent]: isDesktop
    //   })}
    // >
    <div className={classes.root}>
      <Grid
        alignItems="center"
        className={classes.grid}
        container
        justify="center"
        spacing={0}
        style={{ minHeight: '100vh' }}>
        <Grid className={classes.content} item lg={4} xs={10}>
          <Paper className={classes.paper} elevation={2} square>
            {children}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

Empty.propTypes = {
  children: PropTypes.node
};

export default Empty;
